export default __webpack_public_path__ + "static/media/1338.52572dd2.png";